/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./resources/app.ts":
/*!**************************!*\
  !*** ./resources/app.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_CartDotCounter_CartDotCounter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @components/CartDotCounter/CartDotCounter */ "./resources/scripts/components/CartDotCounter/CartDotCounter.ts");
/* harmony import */ var _components_ThumbnailDots_ThumbnailDots__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @components/ThumbnailDots/ThumbnailDots */ "./resources/scripts/components/ThumbnailDots/ThumbnailDots.ts");
/* harmony import */ var _scripts_components_PromoBar_PromoBar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./scripts/components/PromoBar/PromoBar */ "./resources/scripts/components/PromoBar/PromoBar.ts");
/* harmony import */ var _scripts_components_DrawerUpsell_DrawerUpsell__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./scripts/components/DrawerUpsell/DrawerUpsell */ "./resources/scripts/components/DrawerUpsell/DrawerUpsell.ts");




customElements.define("promo-bar", _scripts_components_PromoBar_PromoBar__WEBPACK_IMPORTED_MODULE_2__["default"]);
customElements.define("drawer-upsell", _scripts_components_DrawerUpsell_DrawerUpsell__WEBPACK_IMPORTED_MODULE_3__["default"]);
customElements.define("cart-dot-counter", _components_CartDotCounter_CartDotCounter__WEBPACK_IMPORTED_MODULE_0__["default"]);
customElements.define("thumbnail-dots", _components_ThumbnailDots_ThumbnailDots__WEBPACK_IMPORTED_MODULE_1__["default"]);

/***/ }),

/***/ "./resources/scripts/components/CartDotCounter/CartDotCounter.ts":
/*!***********************************************************************!*\
  !*** ./resources/scripts/components/CartDotCounter/CartDotCounter.ts ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CartDotCounter)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CartDotCounter = /*#__PURE__*/function (_HTMLElement) {
  function CartDotCounter() {
    var _this;
    _classCallCheck(this, CartDotCounter);
    _this = _callSuper(this, CartDotCounter);
    _defineProperty(_this, "cartItemCountElement", null);
    _defineProperty(_this, "handleCartChange", function (event) {
      var cartCount = event.detail.cart.item_count;
      if (_this.cartItemCountElement) {
        _this.cartItemCountElement.textContent = cartCount;
      }
    });
    _this.cartItemCountElement = _this.querySelector(".cart-item-counter");
    _this.handleCartChange = _this.handleCartChange.bind(_this);
    return _this;
  }
  _inherits(CartDotCounter, _HTMLElement);
  return _createClass(CartDotCounter, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      document.addEventListener("cart:change", this.handleCartChange);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/DrawerUpsell/DrawerUpsell.ts":
/*!*******************************************************************!*\
  !*** ./resources/scripts/components/DrawerUpsell/DrawerUpsell.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ DrawerUpsell)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
window.theme = window.theme || {};
var DrawerUpsell = /*#__PURE__*/function (_HTMLElement) {
  function DrawerUpsell() {
    var _this;
    _classCallCheck(this, DrawerUpsell);
    _this = _callSuper(this, DrawerUpsell);
    _defineProperty(_this, "drawer", void 0);
    _defineProperty(_this, "upsellDrawer", void 0);
    _defineProperty(_this, "drawerBtn", void 0);
    _defineProperty(_this, "closeBtn", void 0);
    _this.closing = _this.closing.bind(_this);
    _this.addToCart = _this.addToCart.bind(_this);
    return _this;
  }
  _inherits(DrawerUpsell, _HTMLElement);
  return _createClass(DrawerUpsell, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this,
        _this$drawerBtn;
      this.drawerBtn = document.querySelector(".js-drawer-open-cart");
      this.closeBtn = document.querySelectorAll(".drawer__close-button");
      this.closeBtn.forEach(function (btn) {
        btn.addEventListener("click", function () {
          _this2.closing();
        });
      });
      (_this$drawerBtn = this.drawerBtn) === null || _this$drawerBtn === void 0 || _this$drawerBtn.addEventListener("click", function () {
        _this2.closing();
      });
      var quickAddButtons = this.querySelectorAll(".addToCartQuick");
      quickAddButtons.forEach(function (button) {
        var productVariantId = button.dataset.productvariant;
        if (productVariantId) {
          button.addEventListener("click", function () {
            _this2.addToCart(productVariantId);
          });
        }
      });
      document.addEventListener("DOMContentLoaded", function () {
        if (localStorage.getItem("cartUpsell") === "true") {
          localStorage.removeItem("cartUpsell");
          _this2.drawerBtn = document.querySelector(".js-drawer-open-cart");
          if (_this2.drawerBtn) {
            _this2.drawerBtn.click();
          }
        }
      });
    }
  }, {
    key: "closing",
    value: function closing() {
      this.drawer = document.querySelector("#CartDrawer");
      this.upsellDrawer = this.querySelector(".drawer-upsell");
      if (this.drawer && this.upsellDrawer) {
        if (this.drawer.classList.contains("drawer--is-open")) {
          this.upsellDrawer.style.opacity = "1";
        } else {
          this.upsellDrawer.style.opacity = "0";
        }
      }
    }
  }, {
    key: "addToCart",
    value: function addToCart(variantId) {
      var _this3 = this;
      var body = JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1
        }]
      });
      fetch("/cart/add.js", {
        method: "POST",
        body: body,
        headers: {
          "Content-Type": "application/json",
          accept: "application/json"
        }
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        _this3.closing();
        localStorage.setItem("cartUpsell", "true");
        window.location.reload();
        document.dispatchEvent(new CustomEvent("ajaxProduct:added", {
          detail: {
            cart: window.theme.cart.getCart()
          }
        }));
      })["catch"](function (error) {
        console.error("Error adding item to cart:", error);
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/PromoBar/PromoBar.ts":
/*!***********************************************************!*\
  !*** ./resources/scripts/components/PromoBar/PromoBar.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ PromoBar)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PromoBar = /*#__PURE__*/function (_HTMLElement) {
  function PromoBar() {
    var _this;
    _classCallCheck(this, PromoBar);
    _this = _callSuper(this, PromoBar);
    _defineProperty(_this, "container", void 0);
    _defineProperty(_this, "box", void 0);
    _defineProperty(_this, "promo_bar", void 0);
    _defineProperty(_this, "close", void 0);
    _defineProperty(_this, "slides", void 0);
    _defineProperty(_this, "slideIndex", 0);
    _defineProperty(_this, "intervalId", void 0);
    _this.container = _this.querySelector(".promo-bar-container");
    _this.box = _this.querySelector(".promo-bar-box");
    _this.promo_bar = _this.querySelector(".promo-bar");
    _this.close = _this.querySelector(".promo-close");
    _this.slides = _this.querySelectorAll(".promo-slide");
    return _this;
  }
  _inherits(PromoBar, _HTMLElement);
  return _createClass(PromoBar, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.promo_bar.addEventListener("click", function () {
        return _this2.toggleModal();
      });
      this.close.addEventListener("click", function (e) {
        e.stopPropagation();
        _this2.toggleModal();
      });
      if (this.slides.length > 0) {
        this.slides[0].classList.add("visible");
        if (this.slides.length > 1) {
          this.startSlideRotation();
        }
      }
    }
  }, {
    key: "toggleModal",
    value: function toggleModal() {
      this.box.classList.toggle("active");
      this.container.classList.toggle("overlay");
    }
  }, {
    key: "startSlideRotation",
    value: function startSlideRotation() {
      var _this3 = this;
      this.intervalId = window.setInterval(function () {
        _this3.slides[_this3.slideIndex].classList.remove("visible");
        _this3.slideIndex = (_this3.slideIndex + 1) % _this3.slides.length;
        _this3.slides[_this3.slideIndex].classList.add("visible");
      }, 5000);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/ThumbnailDots/ThumbnailDots.ts":
/*!*********************************************************************!*\
  !*** ./resources/scripts/components/ThumbnailDots/ThumbnailDots.ts ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ThumbnailDots)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ThumbnailDots = /*#__PURE__*/function (_HTMLElement) {
  function ThumbnailDots() {
    var _this;
    _classCallCheck(this, ThumbnailDots);
    _this = _callSuper(this, ThumbnailDots);
    _defineProperty(_this, "productItem", null);
    _defineProperty(_this, "productItemImageWrapper", null);
    _defineProperty(_this, "dots", []);
    _defineProperty(_this, "slider", null);
    _defineProperty(_this, "originalImageSrc", void 0);
    _defineProperty(_this, "originalImageSrcset", void 0);
    _defineProperty(_this, "scrollTimeout", null);
    _defineProperty(_this, "lastScrollTime", 0);
    _defineProperty(_this, "scrollDebounce", 300);
    // Adjusted debounce time
    _defineProperty(_this, "wheelEventCount", 0);
    _defineProperty(_this, "wheelEventThreshold", 3);
    // Reduced threshold for more responsive wheel
    _defineProperty(_this, "secondaryImage", null);
    _defineProperty(_this, "preloadedImages", new Map());
    _defineProperty(_this, "isTransitioning", false);
    _defineProperty(_this, "touchStartX", 0);
    _defineProperty(_this, "touchStartY", 0);
    _defineProperty(_this, "touchEndX", 0);
    _defineProperty(_this, "touchEndY", 0);
    _defineProperty(_this, "isSwiping", false);
    _this.initElements = _this.initElements.bind(_this);
    _this.preloadImages = _this.preloadImages.bind(_this);
    _this.addEventListeners = _this.addEventListeners.bind(_this);
    _this.handleDotClick = _this.handleDotClick.bind(_this);
    _this.handleWheel = _this.handleWheel.bind(_this);
    _this.changeImage = _this.changeImage.bind(_this);
    _this.switchToImage = _this.switchToImage.bind(_this);
    _this.handleTouchStart = _this.handleTouchStart.bind(_this);
    _this.handleTouchMove = _this.handleTouchMove.bind(_this);
    _this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
    _this.resetTransition = _this.resetTransition.bind(_this);
    return _this;
  }
  _inherits(ThumbnailDots, _HTMLElement);
  return _createClass(ThumbnailDots, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initElements();
      this.preloadImages();
      this.addEventListeners();
    }
  }, {
    key: "initElements",
    value: function initElements() {
      var _this$productItem, _this$productItem2;
      var isMobile = window.innerWidth < 768;
      this.productItem = this.closest(".grid__item");
      this.productItemImageWrapper = (_this$productItem = this.productItem) === null || _this$productItem === void 0 ? void 0 : _this$productItem.querySelector(".grid-product__image-mask");
      this.dots = Array.from(this.querySelectorAll(".media-dot"));
      this.secondaryImage = (_this$productItem2 = this.productItem) === null || _this$productItem2 === void 0 ? void 0 : _this$productItem2.querySelector(".grid-product__secondary-image");
      // Store original image source immediately
      if (this.secondaryImage) {
        // if is mobile secondaryImage is actually product-item__primary-image
        if (isMobile) {
          var _this$productItem3;
          this.secondaryImage = (_this$productItem3 = this.productItem) === null || _this$productItem3 === void 0 ? void 0 : _this$productItem3.querySelector(".grid__image-contain");
        }
        this.originalImageSrc = this.secondaryImage.src;
        this.originalImageSrcset = this.secondaryImage.srcset;
        // Set active dot. On mobile the first dot should be active. On desktop the second dot should be active.
        var activeDot = isMobile ? this.dots[0] : this.dots[1];
        activeDot.classList.add("active");
      }
    }
  }, {
    key: "preloadImages",
    value: function () {
      var _preloadImages = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this2 = this;
        var preloadPromises;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              preloadPromises = this.dots.map(function (dot) {
                var mediaUrl = dot.dataset.media;
                if (!mediaUrl || _this2.preloadedImages.has(mediaUrl)) return Promise.resolve();
                return new Promise(function (resolve) {
                  var img = document.createElement("img");
                  img.src = mediaUrl;
                  img.onload = function () {
                    _this2.preloadedImages.set(mediaUrl, img);
                    resolve();
                  };
                  img.onerror = function () {
                    return resolve();
                  }; // Continue even if one image fails to load
                });
              });
              _context.n = 1;
              return Promise.all(preloadPromises);
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function preloadImages() {
        return _preloadImages.apply(this, arguments);
      }
      return preloadImages;
    }()
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this$productItem4,
        _this$productItemImag,
        _this$productItemImag2,
        _this$productItemImag3,
        _this3 = this;
      (_this$productItem4 = this.productItem) === null || _this$productItem4 === void 0 || _this$productItem4.addEventListener("wheel", this.handleWheel.bind(this), {
        passive: false
      });
      (_this$productItemImag = this.productItemImageWrapper) === null || _this$productItemImag === void 0 || _this$productItemImag.addEventListener("touchstart", this.handleTouchStart.bind(this));
      (_this$productItemImag2 = this.productItemImageWrapper) === null || _this$productItemImag2 === void 0 || _this$productItemImag2.addEventListener("touchmove", this.handleTouchMove.bind(this), {
        passive: false
      });
      (_this$productItemImag3 = this.productItemImageWrapper) === null || _this$productItemImag3 === void 0 || _this$productItemImag3.addEventListener("touchend", this.handleTouchEnd.bind(this));
      this.dots.forEach(function (dot) {
        dot.addEventListener("click", function (event) {
          event.preventDefault();
          _this3.handleDotClick(event);
        });
        // Add keyboard accessibility
        dot.addEventListener("keydown", function (event) {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            _this3.handleDotClick(event);
          }
        });
      });
    }
  }, {
    key: "handleDotClick",
    value: function handleDotClick(event) {
      if (this.isTransitioning) return;
      var target = event.currentTarget;
      if (!target.dataset.media) return;
      this.switchToImage(target.dataset.media, target);
    }
  }, {
    key: "handleWheel",
    value: function handleWheel(event) {
      // Only handle horizontal wheel events
      if (Math.abs(event.deltaX) < Math.abs(event.deltaY)) return;
      event.preventDefault();
      this.wheelEventCount += 1;
      if (this.wheelEventCount < this.wheelEventThreshold) return;
      var now = Date.now();
      if (now - this.lastScrollTime < this.scrollDebounce) {
        this.wheelEventCount = 0;
        return;
      }
      if (!this.secondaryImage || this.isTransitioning) return;
      var direction = event.deltaX > 0 ? "next" : "prev";
      this.changeImage(direction);
      this.lastScrollTime = now;
      this.wheelEventCount = 0;
    }
  }, {
    key: "changeImage",
    value: function changeImage(direction) {
      if (!this.dots.length) return;
      var currentIndex = this.dots.findIndex(function (dot) {
        return dot.classList.contains("active");
      });
      if (currentIndex === -1) return;
      var totalDots = this.dots.length;
      var nextIndex = direction === "next" ? currentIndex + 1 : currentIndex - 1;
      // Wrap around
      if (nextIndex >= totalDots) nextIndex = 0;else if (nextIndex < 0) nextIndex = totalDots - 1;
      var nextDot = this.dots[nextIndex];
      var newImageSrc = nextDot.dataset.media;
      if (!newImageSrc) return;
      this.switchToImage(newImageSrc, nextDot);
    }
  }, {
    key: "switchToImage",
    value: function () {
      var _switchToImage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(imageSrc, dot) {
        var _this$slider,
          _this4 = this;
        var preloaded;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!(!this.secondaryImage || this.isTransitioning)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              this.isTransitioning = true;
              // Add loading class for visual feedback
              this.secondaryImage.classList.add("loading");
              // Add no-transition class to slider
              (_this$slider = this.slider) === null || _this$slider === void 0 || _this$slider.classList.add("no-transition");
              // Update active dot immediately for visual feedback
              this.dots.forEach(function (d) {
                return d.classList.remove("active");
              });
              dot.classList.add("active");
              _context2.p = 2;
              // Check if image is preloaded
              preloaded = this.preloadedImages.get(imageSrc);
              if (!(preloaded && preloaded.complete)) {
                _context2.n = 3;
                break;
              }
              // Use preloaded image
              this.secondaryImage.src = imageSrc;
              this.secondaryImage.srcset = imageSrc;
              _context2.n = 4;
              break;
            case 3:
              _context2.n = 4;
              return new Promise(function (resolve) {
                _this4.secondaryImage.onload = function () {
                  return resolve();
                };
                _this4.secondaryImage.onerror = function () {
                  return resolve();
                };
                _this4.secondaryImage.src = imageSrc;
                _this4.secondaryImage.srcset = imageSrc;
              });
            case 4:
              _context2.p = 4;
              // Remove loading state
              this.secondaryImage.classList.remove("loading");
              this.resetTransition();
              this.isTransitioning = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[2,, 4, 5]]);
      }));
      function switchToImage(_x, _x2) {
        return _switchToImage.apply(this, arguments);
      }
      return switchToImage;
    }()
  }, {
    key: "handleTouchStart",
    value: function handleTouchStart(event) {
      this.touchStartX = event.touches[0].clientX;
      this.touchStartY = event.touches[0].clientY;
      this.isSwiping = false;
    }
  }, {
    key: "handleTouchMove",
    value: function handleTouchMove(event) {
      if (event.touches.length > 1) return; // Ignore multi-touch
      this.touchEndX = event.touches[0].clientX;
      this.touchEndY = event.touches[0].clientY;
      // Detect if the user is swiping horizontally more than vertically
      var deltaX = this.touchEndX - this.touchStartX;
      var deltaY = this.touchEndY - this.touchStartY;
      if (Math.abs(deltaX) > Math.abs(deltaY)) {
        this.isSwiping = true;
        event.preventDefault(); // Prevent vertical scrolling
      }
    }
  }, {
    key: "handleTouchEnd",
    value: function handleTouchEnd() {
      if (!this.isSwiping) return;
      var deltaX = this.touchEndX - this.touchStartX;
      if (Math.abs(deltaX) > 30) {
        // Adjust threshold as needed
        var direction = deltaX < 0 ? "next" : "prev";
        this.changeImage(direction);
      }
    }
  }, {
    key: "resetTransition",
    value: function resetTransition() {
      var _this5 = this;
      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
      }
      this.scrollTimeout = window.setTimeout(function () {
        var _this5$slider;
        (_this5$slider = _this5.slider) === null || _this5$slider === void 0 || _this5$slider.classList.remove("no-transition");
        _this5.scrollTimeout = null;
      }, 150); // Slightly longer timeout for smoother transition
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _this$productItem5;
      (_this$productItem5 = this.productItem) === null || _this$productItem5 === void 0 || _this$productItem5.removeEventListener("wheel", this.handleWheel);
      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/styles/app.css":
/*!**********************************!*\
  !*** ./resources/styles/app.css ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/shopify-theme/assets/edition": 0,
/******/ 			"shopify-theme/assets/edition": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkqnts_dk"] = self["webpackChunkqnts_dk"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["shopify-theme/assets/edition"], () => (__webpack_require__("./resources/app.ts")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["shopify-theme/assets/edition"], () => (__webpack_require__("./resources/styles/app.css")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;